import { apiAssigneeDesigner } from '@/api/task.api'
import { errorMessage } from 'modules/Error'

export const Designers = {
  state: {
    onProjectDesigners: [],
    othersDesigners: []
  },
  mutations: {
    setOnProjectDesigners (state, payload) {
      state.onProjectDesigners = [...payload]
    },
    
    setOthersDesigners (state, payload) {
      state.othersDesigners = payload
    }
  },
  actions: {
    updateOnProjectDesigners ({commit}, payload) {
      commit("setOnProjectDesigners", payload)
    },

    updateOthersDesigners ({commit}, payload) {
      commit("setOthersDesigners", payload)
    },

    async assigneeDesigner ({ dispatch, getters }, payload) {
      const { projectId, taskId, designer } = payload
      const [err, data] = await apiAssigneeDesigner(projectId, taskId, designer.id)
      if (err) return errorMessage(err, 'Unable to Assign Designer!')

      const isNotOnProjectDesigners = getters.getOnProjectDesigners.findIndex(user => user.id === designer.id) === -1

      if (isNotOnProjectDesigners) {
        const assignedDesigner = getters.getOthersDesigners.filter(user => user.id === designer.id)[0]
        assignedDesigner.onTask = true
        dispatch('updateOthersDesigners', getters.getOthersDesigners.filter(user => user.id !== designer.id))
        dispatch('updateOnProjectDesigners', [...getters.getOnProjectDesigners, assignedDesigner])
      }

      const isDesignerNotInProject = getters.getProjectUsers && getters.getProjectUsers.findIndex(user => user.id === designer.id) === -1
      if (isDesignerNotInProject) {
        dispatch('updateProjectProperties', { projectUsersFeData: [...getters.getProjectUsers, data] })
      }

      dispatch('updateDashboardTaskProperties', { taskId,
        properties: { 
          designerId: designer.id, 
          designerAvatarKey: designer.avatarKey,  
          designerFullName: `${designer.name} ${designer.surname}`
        }
      })

      return dispatch('updateActiveTaskProperties', { taskId,
        properties: { designerId: designer.id }
      })
    }
  },
  getters: {
    getOnProjectDesigners (state) {
      return state.onProjectDesigners
    },

    getOthersDesigners (state) {
      return state.othersDesigners
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Designers.js